import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { GENERAL__SEARCH } from 'translations/constants';
import { ReactComponent as KioskSearchIcon } from '../../../assets/icons/KioskSearchIcon.svg';
import { KIOSK_SELECTION_TOKENS, KioskSearchInput, KioskSearchWrapper } from '../styles';

interface KioskSearchFieldProps {
  value: string;
  onChange: (value: string) => void;
}

/** Always-visible search field. Turns green while a query is active. */
const KioskSearchField = ({ value, onChange }: KioskSearchFieldProps) => {
  const [t] = useTranslation();
  const active = value.trim().length > 0;
  return (
    <KioskSearchWrapper active={active}>
      <KioskSearchInput
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={t(GENERAL__SEARCH)}
        inputProps={{ 'aria-label': t(GENERAL__SEARCH), id: 'kiosk-search' }}
      />
      <Box sx={{ display: 'flex', color: KIOSK_SELECTION_TOKENS.accent }}>
        <KioskSearchIcon />
      </Box>
    </KioskSearchWrapper>
  );
};

export default KioskSearchField;
